import { FC, useEffect, useRef, useState } from 'react';

import styles from './TabNavigator.module.scss';

interface TabNavigatorProps {
  options: string[];
  value?: string;
  onChange?: (value: string) => void;
}

const TabNavigator: FC<TabNavigatorProps> = ({ options, value, onChange }) => {
  const navRef = useRef<HTMLDivElement>(null);
  const buttonRefs = useRef<(HTMLButtonElement | null)[]>([]);
  const [thumbStyle, setThumbStyle] = useState<{ left: number; width: number }>({ left: 0, width: 0 });

  useEffect(() => {
    const activeIndex = options.findIndex((option) => option === value);
    if (activeIndex !== -1 && buttonRefs.current[activeIndex]) {
      const button = buttonRefs.current[activeIndex];
      const nav = navRef.current;
      if (button && nav) {
        setThumbStyle({
          left: button.offsetLeft,
          width: button.offsetWidth,
        });
      }
    }
  }, [value, options]);

  const handleClick = (option: string) => {
    onChange?.(option);
  };

  return (
    <div className={styles.tabNavigator} ref={navRef}>
      <div
        className={styles.thumb}
        style={{
          transform: `translateX(${thumbStyle.left}px)`,
          width: `${thumbStyle.width}px`,
        }}
      />
      {options.map((option, index) => (
        <button
          key={option}
          ref={(el) => (buttonRefs.current[index] = el)}
          className={`${styles.tabButton} ${value === option ? styles.active : ''}`}
          onClick={() => handleClick(option)}
        >
          {option}
        </button>
      ))}
    </div>
  );
};

export default TabNavigator;
